import React, { useEffect, useState } from 'react'
import useVideoConfigS3 from '../HelperComponent/useVideoConfigS3';


const useVdieoHandleS3 = (video=null,upKey=null,delKey=null) => {

    const [s3,bucketName] = useVideoConfigS3([]);
    const [videoProgress, setProgress] = useState(0);
    const [videoUrl, setFileUrl] = useState('');
    const [videoKey, setFileKey] = useState('');

    const [uploadFile, setFile] = useState(null);
    const [deleleFileKey, setDeleteFile] = useState(null);


    useEffect(() => {
      setDeleteFile(delKey);
      setFile(video);
      setProgress(0);
      setFileUrl('')
    }, [video,delKey]);
    
      const handleDelete = (delFile) => {

          const params = {
      
              Bucket: bucketName,
              Key: delFile,
            };
          s3.deleteObject(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              console.log(data);
            });
        
      }
      if(deleleFileKey){
          handleDelete(deleleFileKey);
          setDeleteFile(null);
          setFileUrl(null);
      }

    const handleUpload = (video) => {
        const extension = video.name.split(".").pop();
        const videoName = new Date().getTime()+"."+extension;

 
            const params = {
 
              Bucket: process.env.REACT_APP_S3_BUCKET_VIDEOS,
              Key: upKey +"/"+videoName,
              Body: video,
            };
      
            s3.upload(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              setFileUrl(data.Location);
              setFileKey(data.Key);
            })
            .on("httpUploadProgress", (evt) => {
              const progressPercentage = parseInt(
                (evt.loaded * 100) / evt.total
              );
              setProgress(progressPercentage);
            });

    };

    if(uploadFile){
        handleUpload(uploadFile);
        setFile(null);
    }

    return [videoUrl,videoKey,videoProgress];
}

export default useVdieoHandleS3